import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import cn from 'classnames';
import styles from './Wireframe.scss';

class Wireframe extends Component {
  render() {
    const { client, t } = this.props;
    return (
      <div className={cn(styles.RightRow, this.props.className)}>
        {client ? (
          <div>
            <div className={styles.RealtorCard}>
              <div className={styles.RealtorInfo}>
                <div className={styles.Avatar}></div>
                <div className={styles.Name}></div>
                <div className={styles.Position}></div>
              </div>

              <div className={styles.RealtorContacts}>
                <div className={styles.RealtorContact}></div>
                <div className={styles.RealtorContact}></div>
              </div>
              <div className={styles.RealtorSocial}>
                <div className={styles.RealtorSocialTitle}>
                  {t('components.building.main.rightWireframe.social')}
                </div>
                <div className={styles.SocialLinks}>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className={styles.Section}>
              <h3 className={styles.Title}>
                {t('components.building.main.rightWireframe.builder')}
              </h3>
              <div className={styles.InnerBuilder}>
              </div>
            </div>
            <div className={styles.Section}>
              <h3 className={styles.Title}>
                {t('components.building.main.rightWireframe.commission')}
              </h3>
              <div className={styles.Inner}>
                <div className={styles.TextLine}></div>
                <div className={styles.TextLine}></div>
                <div className={styles.TextLine}></div>
              </div>
            </div>
            <div className={styles.Section}>
              <h3 className={styles.Title}>
                {t('components.building.main.rightWireframe.contacts')}
              </h3>
              <div className={styles.InnerContacts}>

              </div>
            </div>
            <div className={styles.Section}>
              <h3 className={styles.Title}>
                {t('components.building.main.rightWireframe.docs')}
              </h3>
              <div className={styles.Inner}>
                <div className={styles.DocumentRow}>
                  <div className={styles.Label} />
                  <div className={styles.Name} />
                </div>
                <div className={styles.DocumentRow}>
                  <div className={styles.Label} />
                  <div className={styles.Name} />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(Wireframe);



// WEBPACK FOOTER //
// ./src/components/Building/Main/RightWireframe/Wireframe.js